import Vue from 'vue'
import WizardPanel from '../../components/Wizard/ResultPanel'

Vue.component("wizard-panel", WizardPanel);

const apps = document.querySelectorAll('.vue-app');

Array.prototype.forEach.call(
  apps,
  el =>
    new Vue({
      el,
      template: el.innerHTML
    })
);